import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

const ImportSwaggerProgress: React.FC<{ progress: number }> = ({ progress }) => (
  <Box sx={{ py: 1 }}>
    <Typography sx={{ mb: 1.5, fontSize: '0.875rem', fontWeight: 600 }}>Importing... {progress}%</Typography>
    <LinearProgress variant="determinate" value={progress} />
  </Box>
);

export default ImportSwaggerProgress; 